// @flow
import React, { type Node, Fragment } from 'react';
import { ErrorDisplay } from '../../../commons/molecules';
import { AnalyticsCachedEvent } from '@tectonics/analytics';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';
import { useTranslateErrorMessageTags } from '@tectonics/controller/error-messages';
import { Link } from '../../../commons/atoms';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

type Props = {|
  submitError: PlaceOrderErrorPayload,
|};

export function SubmitErrorDisplay({ submitError }: Props): Node {

  const translatedError = useTranslateErrorMessageTags(submitError.message);

  return (
    <ErrorDisplay>
      <AnalyticsCachedEvent eventType="error" />
      {translatedError.map(({ text, tag }, i) => {
        if (tag !== 'support') {
          return <Fragment key={i}>{text}</Fragment>;
        }

        return <SupportLink key={i}>{text}</SupportLink>;
      })}
    </ErrorDisplay>
  );
}

type SupportLinkProps = {
  +children: Node;
}

function SupportLink({ children }: SupportLinkProps): Node {
  const country = getCountry(useIncomingPayment());

  if (country !== 'br') {
    throw new Error('support tag translation not supported by contries other than br');
  }

  return (
    <Link href="https://ajuda.ebanx.com/hc/pt-br" target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
}
